<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";
    import Spinner from "../components/spinner.svelte"; 
    import DataTable from "../../components/data-table.svelte";
    import moment from "moment";
    import Button from "../components/button.svelte";
    
    export let providerId; 

    let allLogs = [];
    let logs = [];
    let columnDefs = [{ type: 'date-euro', targets: [2] }];
    let order = [[2, "desc"]]
    let isPageLoading = false;
    let logsPerSync = [];
    let selectedSyncRunId;
    let selectedSeverity = false;
    let isRefreshButtonLoading = false;

    onMount(async () => {
        await getLogs();
    });

    const getLogs = async () => {

        isPageLoading = true;

        let resp = await wrappedFetch(`/api/cloudConfig/GetAllSyncLogs?providerId=${providerId}`, {
            method: "post",
        });

        let result = await resp.json();
        
        allLogs= result.syncLogs;
        logsPerSync = result.logsPerSync;
        selectedSyncRunId = logsPerSync[0].syncRunId;
        handleChangeFilter();

        isPageLoading = false;

    };

    const getLogsBySyncRunId = async () => {

        let resp = await wrappedFetch(`/api/cloudConfig/GetSyncLogsBySyncRunId?providerId=${providerId}&syncRunId=${selectedSyncRunId}`, {
            method: "post",
        });

        allLogs = await resp.json();
    }

    const handleChangeSyncLog = async()=>{

        if (selectedSyncRunId == -1)
        {
            let minSyncRunId = logsPerSync[logsPerSync.length - 1].syncRunId - 1;
            let resp = await wrappedFetch(`/api/cloudConfig/GetTimestampForPreviousTenRuns?providerId=${providerId}&maxSyncRunId=${minSyncRunId}`, {
                method: "post",
            });
            let result = await resp.json(); 
            logsPerSync = logsPerSync.concat(result)
            
            selectedSyncRunId =  minSyncRunId;
             
        }

        await getLogsBySyncRunId();
        handleChangeFilter();
        
    }
    
    const handleChangeFilter = () => {
        if (selectedSeverity == "E") logs = allLogs.filter((u) => u.level == "Error");
        else if (selectedSeverity == "W") logs = allLogs.filter((u) => u.level == "Warning");
        else if(selectedSeverity == "I") logs = allLogs.filter((u) => u.level == "Information");
        else logs = allLogs;
    };

    let columns = [
            { data: "level", title: "Severity"}, 
            { data: "message",title: "Message"}, 
            { data: "timestamp", title: "Timestamp", type: "date-euro", 
                render: function(val) { 
                    return moment(val).format("DD/MM/YYYY HH:mm:ss");
                } 
            } 
        ];
</script>

<svelte:head>
    <title> Detailed Logs | Wavenet Nimbus </title>
</svelte:head>

<div class="row">
    <div class="col-12">
        <a class="btn btn-grey mb-3" href="/app/export/{providerId}/detailedLogs">
            <i class="fas fa-arrow-left" />
            Back
        </a>
    </div>
</div>

<h1>Detailed logs</h1>
<p>These are the detailed logs created by the sync process.</p>

{#if isPageLoading}
    <Spinner />
{:else}
    {#if providerId > 0}
    <Card>
        <div slot="body">
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-4 order-sm-1">                    
                        <label for="role" style="display:block;">Filter:</label>
                        <select
                            style="width:300px;"
                            name="logType"
                            class="custom-select"
                            bind:value={selectedSeverity}
                            on:change={handleChangeFilter}>
                                <option selected="selected" value="A">All Logs</option>
                                <option value="I">Information</option>
                                <option value="E">Errors</option>
                                <option value="W">Warning</option>
                        </select>
                    </div>
                     <div class="col-lg-4 order-sm-2">                    
                        <label for="role" style="display:block;">Available Logs:</label>
                        <select
                            style="width:300px;"
                            name="logType"
                            class="custom-select"
                            bind:value={selectedSyncRunId}  
                            on:change={handleChangeSyncLog}>
                                {#each logsPerSync as l}                                
                                    <option value={l.syncRunId}>{l.syncRef}</option>                              
                                {/each}
                                <!-- <hr style="border-top: 1px dotted #2e817d !important;"/> -->
                                <option value={-1} class="text-primary">Load more...</option>
                        </select>
                    </div>
                    <div class="col-lg-4 d-flex justify-content-end align-items-baseline order-sm-3">     
                        <Button
                            style={'width:147.5px;'}
                            title={'Get logs for the last run sync.'}
                            buttonClass={'btn-primary float-left'}
                            buttonText={'<span class="material-icons">autorenew</span> Refresh'}
                            isConfirm={false}
                            on:click={ async () => {
                                isRefreshButtonLoading = true;
                                await getLogsBySyncRunId();
                                isRefreshButtonLoading = false;
                            }}
                            isLoading={isRefreshButtonLoading}
                        />
                    </div>
                </div>
            </div>

            <DataTable  bind:data={logs} paging={true} {order} {columnDefs} DataLength={logs.length} {columns} message="No logs available." />
           
        </div>
    </Card>
    {/if}
{/if}